import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { LoggableHistoryEntry } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class LoggableHistoryService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  async getLoggableHistory(
    parameters: any = {
      objectClass: null,
      objectId: null,
      page: null,
      sort: null,
      direction: null,
    },
    schema: any = { version: null }
  ): Promise<{
    items: LoggableHistoryEntry[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    const result = await this.core.services.loggableHistory.getList(parameters, schema)
    return {
      items: (result?.items ?? []).map(item => new LoggableHistoryEntry(item)),
      paginator: result?.paginator,
    }
  }
}
